import utils from '@/mixins/utils.js'
import { getQuantidadePessoasAtendidas } from './functions.js'

function dadosExpandidosComoJson(item) {
  const d = item.dados
  if (d == null || d === '') return ''
  if (typeof d === 'string') return d
  try {
    return JSON.stringify(d)
  } catch {
    return ''
  }
}

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado no filtro.
 * @param {Object|null} equipe Equipe selecionada.
 * @returns {Object}
 */
export function getDataFields(mes = null, equipe = null) {
  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
          item.idade
        } ${item.idade > 1 ? 'anos' : 'ano'})`
        return idade
      },
    },
    Mãe: 'no_mae',
    CPF: 'nu_cpf',
    CNS: 'nu_cns',
    Microárea: 'micro_area',
    'Cadastrado por': 'no_profissional',
    Atendimentos: {
      callback: (item) => {
        return getQuantidadePessoasAtendidas(item, mes, equipe)
      },
    },
    Dados: {
      callback: (item) => dadosExpandidosComoJson(item),
    },
  }
}

export const infoHtml = ``
